import React from "react";
import { RiseLoader } from "react-spinners";
import { Spinner } from "reactstrap";

/**
 * Generates a loading element if the isLoading parameter is true, otherwise returns null.
 * @param {boolean} isLoading - A boolean value indicating whether to display the loading element or not.
 * @returns {JSX.Element | null} Returns a loading element (JSX) if isLoading is true, or null if it's false.
 */
export function loaderElement(isLoading) {
  if (isLoading === true) {
    return (
      <div className="loader-overlay">
        <div className="loader-wrapper d-flex justify-content-center align-items-center">
          <RiseLoader color="#0072BC" loading={true} margin={0} size={15} speedMultiplier={1} />
        </div>
      </div>
    );
  } else {
    return null;
  }
}

/**
 * Renders a loader component when isLoading is true.
 * @param {boolean} isLoading - A flag indicating whether the component should display the loader.
 * If true, the loader is displayed; otherwise, nothing is rendered.
 * @returns {JSX.Element | null} The loader component or null if isLoading is false.
 */
export function loaderComponent(isLoading) {
  if (isLoading === true) {
    return (
      <div className="loader-wrapper d-flex justify-content-center align-items-center mt-3">
        <RiseLoader color="#0072BC" loading={true} margin={0} size={15} speedMultiplier={1} />
      </div>
    );
  } else {
    return null;
  }
}
/**
 * Returns a React component for a button containing a spinner if loading.
 * @param {boolean} isLoading - Determines if the loading spinner should be displayed.
 * @returns {JSX.Element|null} A Spinner component if loading, otherwise null.
 */
export function spinnerButton(isLoading) {
  if (isLoading === true) {
    return <Spinner size="sm" color="secondary" type="grow" />;
  }
  return null;
}
